// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  withCredentials: true,
});

// Add response interceptor to handle auth errors globally
api.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response) {
      const status = error.response.status;
      
      // If unauthorized or forbidden, clear auth data and redirect to login
      if (status === 401 || status === 403) {
        console.warn(`API ${status} error - clearing auth data`);
        localStorage.removeItem("authUser");
        localStorage.removeItem("jwtToken");
        
        // Only redirect if not already on login page
        if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
          console.warn("Redirecting to login page");
          window.location.href = "/login";
        }
      }
    }
    
    // Always reject the promise so calling code can handle the error
    return Promise.reject(error);
  }
);

export default api;
